import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

type ConfirmDeleteDialogProps = {
	open: boolean;
	title: string;
	resourceName: string;
	selectedCount: number;
	isDeleting?: boolean;
	onClose: () => void;
	onConfirm: () => void;
};

export default function ConfirmDeleteDialog({ open, title, resourceName, selectedCount, isDeleting, onClose, onConfirm }: ConfirmDeleteDialogProps) {
	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<Typography variant="body2">
					Delete {selectedCount} selected {selectedCount === 1 ? resourceName : `${resourceName}s`}? This cannot be undone.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={isDeleting}>
					Cancel
				</Button>
				<Button color="error" variant="contained" onClick={onConfirm} disabled={isDeleting || selectedCount === 0}>
					Delete
				</Button>
			</DialogActions>
		</Dialog>
	);
}
